import { useAuth } from "stores/useAuth";

export const useSessionID = () => {
  const sessionID = useAuth(({ sessionID }) => sessionID) as string;

  return sessionID;
};
